import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(theme => ({
  calendar: { width: "100%" }
}));
